import { UNLOCK_VISUAL } from "@/lib/unlock";

/**
 * Tiny visual indicator for a compound's unlock state.
 * Variants:
 *   - "dot"   : 8px coloured dot only (use inline, e.g. next to a word)
 *   - "chip"  : dot + uppercase label inside a thin border (use on hero header)
 *   - "chip-sm" : compact chip for inline list rows
 */
export default function UnlockBadge({ state, known, total, variant = "chip", className = "" }) {
  const v = UNLOCK_VISUAL[state] || UNLOCK_VISUAL.locked;
  const showCount = typeof known === "number" && typeof total === "number" && total > 0;
  const title = showCount ? `${known}/${total} kanji known` : v.label;

  if (variant === "dot") {
    return (
      <span
        data-testid={`unlock-dot-${state}`}
        title={title}
        aria-label={title}
        className={`inline-block w-2 h-2 rounded-full shrink-0 ${className}`}
        style={{ background: v.dot }}
      />
    );
  }
  const sm = variant === "chip-sm";
  return (
    <span
      data-testid={`unlock-chip-${state}`}
      title={title}
      className={`inline-flex items-center gap-1.5 border bg-washi/70 ${sm ? "px-1.5 py-0.5" : "px-2 py-1"} ${className}`}
      style={{ borderColor: v.border, color: v.border }}
    >
      <span
        className={`rounded-full ${sm ? "w-1.5 h-1.5" : "w-2 h-2"}`}
        style={{ background: v.dot }}
      />
      <span className={`font-sans uppercase tracking-[0.2em] ${sm ? "text-[8px]" : "text-[9px]"}`}>
        {v.label}{showCount ? ` · ${known}/${total}` : ""}
      </span>
    </span>
  );
}
